import React from 'react'
import '@yaireo/tagify/dist/tagify.css'
import _ from 'lodash'
import RenderWhen from '../../../components/RenderWhen/RenderWhen'
import {connect} from 'react-redux'
import { Paper, TextField } from 'material-ui'
import Button from 'material-ui/RaisedButton'
import userService from '../../../services/user-service'
import ReferralService from '../../../services/referral.service'

class SocialMediaRewardDefinitionIframe extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
      message: null,
      inviteeNumber: ''
    }
  }

  componentDidMount = async () => {
    this.setState({ user: await userService.getCurrentUser() })
  };

  getLink = async () => {
    const { user, inviteeNumber } = this.state
    const { id, tenantId } = user || {}
    const data = { userId: id, tenantId, inviteeNumber }
    const response = await ReferralService.getLinkForUser(data)
    this.setState({ link: response.url, message: response.message })
  };

  render() {
    const { inviteeNumber, message } = this.state
    return (
      <RenderWhen
        requiredPermissions={['refer_users']}
        currentUser={_.get(this.props, 'loginState.user')}
        authorized={
          <div style={{width: '100%', margin: '0 auto'}}>
            <div style={{ margin: '0 10%' }}>
              <h3 style={{ margin: '30px 0px' }}>Send Invite</h3>
              <Paper>
                <div style={{ width: '90%', margin: '0 auto', padding: 30 }}>
                  <div>
                    <img
                      src="https://rules.casa.croma.com/public-html/cromapromo/refer_a_friend_image.jpg"
                      alt="logo"
                      style={{ width: '100%', marginBottom: 30 }}
                    />
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1, marginTop: 10 }}>Enter the number to invite:</div>
                    <TextField
                      value={inviteeNumber}
                      type="number"
                      onChange={event => {
                        if (event.target.value.length <= 10)
                          this.setState({ inviteeNumber: event.target.value, message: null })
                      }}
                      inputStyle={{ textAlign: 'center' }}
                      style={{ width: '50%', marginLeft: 15, flex: 1, textAlign: 'center' }}
                    />
                    <div style={{ flex: 1 }} />
                  </div>
                </div>
                {message && <div style={{textAlign: 'center', marginBottom: 20}}>{message}</div>}
                <div style={{ textAlign: 'center', paddingBottom: 50 }}>
                  <button
                    style={{
                      border: '2px solid #f26155',
                      height: 40,
                      width: 150,
                      borderRadius: 5,
                      marginBottom: 50,
                      backgroundColor: '#f26155'
                    }}
                    onClick={() => this.getLink()}
                  >
                    <span style={{ color: 'white', fontSize: 14 }}>Send Link</span>
                  </button>
                </div>
              </Paper>
            </div>
          </div>
          }
          />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState
  }
}

export default connect(mapStateToProps)(SocialMediaRewardDefinitionIframe)



// WEBPACK FOOTER //
// ./src/routes/CromaRseReferral/containers/index.js